const GroupColors = [
    'Yellow', 'LightCoral', 'LightSkyBlue', 'Yellow', 'LightYellow', 'Yellow', 'LightYellow', 'LightGreen', 'LightGreen', 'LightGreen', 'LightYellow'
]

export default GroupColors;